var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"fx-data-management\" class=\"data-mng-container container-fluid\">\r\n\r\n    <div id=\"fx-data-management-menu\" class=\"fx-data-management-menu\"></div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <h3>\r\n                <span id=\"fx-data-managment-header-title\"></span>\r\n                <span id=\"fx-data-managment-resource-title\"></span>\r\n            </h3>\r\n\r\n        </div>\r\n    </div>\r\n\r\n    <div id=\"fx-data-management-content-holder\"></div>\r\n\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/main.hbs
// module id = 64
// module chunks = 0